// utils/domainUtils.js
// Funktion zur Bestimmung des App-Namens basierend auf der Domain

export function getAppName () {
  const hostname = window.location.hostname
  
  // Spezifische Domain-Mappings
  if (hostname === 'engineersknowledgebase.com') {
    return 'ALT - Knowledge'
  }
  
  if (hostname === 'asclepionwiki.com') {
    return 'Asclepion Wiki'
  }
  
  // Für andere Domains: Domain-Name verwenden oder "Wiki"
  // Entferne "www." falls vorhanden
  const domain = hostname.replace(/^www\./, '')
  
  // Wenn localhost oder IP, zeige "Wiki"
  if (domain === 'localhost' || domain === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(domain)) {
    return 'Wiki'
  }
  
  // Extrahiere den Hauptteil der Domain (z.B. "example" aus "example.com")
  const domainParts = domain.split('.')
  if (domainParts.length >= 2) {
    const mainDomain = domainParts[0]
    // Erster Buchstabe groß, Rest klein
    return mainDomain.charAt(0).toUpperCase() + mainDomain.slice(1).toLowerCase() + ' Wiki'
  }
  
  return 'Wiki'
}

